export default function WizardPanel({ title, subtitle, status, children, bottomNav }) {
  return (
    <div className="flex-grow-1 px-4 py-3" style={{ minWidth: 0 }}>
      <div className="d-flex align-items-center justify-content-between">
        <h5 className="mb-0 font-weight-bold">{title}</h5>
        {status}
      </div>
      {subtitle && <p className="text-muted small mb-3 mt-1">{subtitle}</p>}
      <div>{children}</div>
      {bottomNav}
    </div>
  );
}
